import { PaymentMethodsApiService } from '../../common/services/payment-methods.api.service';
import { PaymentMethodModel } from '../../common/models/payment-method.model';
import { EnumeratorsApiService } from '../../common/services/enumerators.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';
import PAYMENT_SERVICE from '../../common/enums/paymentService';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
    enums: null,
  },
  getters: {
    getAllPaymentMethods: state => state.items,
    getStatus: state => state.status,
    getPaymentMethod: state => id => state.items.find(item => item.id === id),
    getPaymentMethodsIds: state => state.items.map(paymentMethod => paymentMethod.id),
    getEnums: state => state.enums,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_ITEM(state, data) {
      const arrayIndex = state.items.findIndex(item => item.id === data.id);

      if (arrayIndex === -1) {
        state.items.push(data);
      } else {
        this.$app.$set(state.items, arrayIndex, data);
      }
    },
    SET_ENUMS(state, data) {
      if (!state.enums) {
        state.enums = data;
      } else {
        state.enums.update(data);
      }
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAllPaymentMethods({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return PaymentMethodsApiService.getAll(builder => {
        builder.whereEquals([PaymentMethodModel.ATTR_PAYMENT_SERVICE], PAYMENT_SERVICE.CARRIER);
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchPaymentMethod({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return PaymentMethodsApiService.get(id)
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchPaymentMethodEnumerators({ commit, dispatch }, enums) {
      commit('FETCH_REQUEST');

      return EnumeratorsApiService.get(builder => {
        builder.with(enums);
      })
        .then(response => {
          commit('SET_ENUMS', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
